import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import OrdemDeServicoItemService from "./OrdemDeServicoItemService";
import PedidoDeCompraService from "./PedidoDeCompraService";
import UtilDateTime from "@/utils/UtilDateTime";

export default {

    async criaAprovacaoCoordenadores(aprovadoresValores = []){

        let aprovadores;

        try{

            aprovadoresValores = aprovadoresValores.map((aprovador)=>{

                return{
                    aprovador: aprovador.aprovador,
                    tipo: "Coordenador",
                    status: "Valido",
                    decisao: "A decidir"
                }

            });

            // //Adiciona o Fernando (Diretor) como Diretor
            // aprovadoresValores.push({
            //     aprovador:"5811ab9a-da39-4d86-883f-bc451003ca51",
            //     tipo: "Diretor",
            //     status: "Valido",
            //     decisao: "A decidir"
            // });

            // Adiciona o Milton (Diretor) como Diretor
            aprovadoresValores.push({
                aprovador:"f9a4b491-a7a4-400a-8d41-ce859df30837",
                tipo: "Diretor",
                status: "Valido",
                decisao: "A decidir"
            });

            aprovadores = await ERP.postMany(Schema.PEDIDO_DE_COMPRA_APROVADORES,aprovadoresValores);
            if(aprovadores.status != 200){
                throw aprovadores;
            }

            console.log(aprovadores);

        }catch(e){

            console.log(e);
            return aprovadores;

        }

        return aprovadores;

    },

    async alteraAprovador(aprovadorValores = {}){

        let pedidoDeCompraAprovador;

        try{

            pedidoDeCompraAprovador = await ERP.patchOne(Schema.PEDIDO_DE_COMPRA_APROVADORES, aprovadorValores);
            if(pedidoDeCompraAprovador.status != 200){
                throw pedidoDeCompraAprovador;
            }

            console.log(pedidoDeCompraAprovador);

        }catch(e){

            console.log(e);
            return pedidoDeCompraAprovador;

        }

        return pedidoDeCompraAprovador;

    },

    async alteraAprovadores(aprovadoresValores = []){

        let pedidoDeCompraAprovadores;

        try{

            pedidoDeCompraAprovadores = await ERP.patchMany(Schema.PEDIDO_DE_COMPRA_APROVADORES, aprovadoresValores);
            if(pedidoDeCompraAprovadores.status != 200){
                throw pedidoDeCompraAprovadores;
            }

            console.log(pedidoDeCompraAprovadores);

        }catch(e){

            console.log(e);
            return pedidoDeCompraAprovadores;

        }

        return pedidoDeCompraAprovadores;

    },

    async decisaoDoCoordenador(pedidoDeCompraID, decisaoValores={}){

        let pedidoDeCompra;

        try{

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //====================== Usuário Decisor ===========================//
            //==================================================================//

            let usuarioDecisor = decisaoValores.grupo == "Administradores" ? "Administrador" : "Coordenador";

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //=================== Pega o Pedido de Compra ======================//
            //==================================================================//

            pedidoDeCompra = await ERP.getOneById(Schema.PEDIDO_DE_COMPRA, pedidoDeCompraID);
            if(pedidoDeCompra.status != 200){
                throw pedidoDeCompra;
            }

            //==================================================================//
            //=============== Pega o Pedido de Compra Itens ====================//
            //==================================================================//

            let pedidoDeCompraItens = await ERP.getManyById(Schema.PEDIDO_DE_COMPRA_ITENS, pedidoDeCompra.data.itens);
            if(pedidoDeCompraItens.status != 200){
                throw pedidoDeCompraItens;
            }

            //==================================================================//
            //==== Pega Ordens de Serviço Item dos Itens do Pedido de Compra ===//
            //==================================================================//

            let ordemDeServicoItensIDs = pedidoDeCompraItens?.data?.map(({ordemDeServicoItem})=>ordemDeServicoItem);

            let ordemDeServicoItens = await ERP.getManyById(Schema.ORDEM_DE_SERVICO_ITENS, ordemDeServicoItensIDs);
            if(ordemDeServicoItens.status != 200){
                throw ordemDeServicoItens;
            }

            //==================================================================//
            //=============== Pega o Pedido de Compra Parcelas =================//
            //==================================================================//

            let pedidoDeCompraParcelas = await ERP.getManyById(Schema.PEDIDO_DE_COMPRA_PARCELAS, pedidoDeCompra.data.parcelas);
            if(pedidoDeCompraParcelas.status != 200){
                throw pedidoDeCompraParcelas;
            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //========== Executa a Decisão como um Administrador ===============//
            //==================================================================//

            if(usuarioDecisor == "Administrador"){

                //==================================================================//
                //========== Executa a Decisão como um Administrador ===============//
                //=========== Pega os Aprovadores do Pedido de Compra ==============//
                //==================================================================//

                let pedidoDeCompraAprovadores = await ERP.getManyById(Schema.PEDIDO_DE_COMPRA_APROVADORES, pedidoDeCompra.data.aprovadores);
                if(pedidoDeCompraAprovadores.status != 200){
                    throw pedidoDeCompraAprovadores;
                }

                //==================================================================================//
                //================== Executa a Decisão como um Administrador =======================//
                //======== Decide todas as Aprovações de Coordenadores do Pedido de Compra =========//
                //==================================================================================//

                let pedidoDeCompraAprovadoresValores = pedidoDeCompraAprovadores.data.reduce((acc,pedidoDeCompraAprovador)=>{

                    if(pedidoDeCompraAprovador.tipo == "Coordenador"){

                        acc.push({
                            id: pedidoDeCompraAprovador.id,
                            decisao: decisaoValores.decisao,
                            justificativa: decisaoValores.justificativa,
                            dataDecisao: UtilDateTime.toFormatUTC({dateTime:decisaoValores.dataDecisao}),
                        });

                    }

                    return acc;

                },[]);

                pedidoDeCompraAprovadores = await this.alteraAprovadores(pedidoDeCompraAprovadoresValores);
                if(pedidoDeCompraAprovadores.status != 200){
                    throw pedidoDeCompraAprovadores;
                }

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //=========== Executa a Decisão como um Coordenador ================//
            //==================================================================//

            if(usuarioDecisor == "Coordenador"){

                //=========================================================================//
                //=============== Executa a Decisão como um Coordenador ===================//
                //======== Aplica a Decisão do Coordenador do Pedido de Compra ============//
                //=========================================================================//

                let pedidoDeCompraAprovadorValores = {
                    id: decisaoValores.aprovador,
                    decisao: decisaoValores.decisao,
                    justificativa: decisaoValores.justificativa,
                    dataDecisao: UtilDateTime.toFormatUTC({dateTime:decisaoValores.dataDecisao}),
                }

                let pedidoDeCompraAprovador = await this.alteraAprovador(pedidoDeCompraAprovadorValores);
                if(pedidoDeCompraAprovador.status != 200){
                    throw pedidoDeCompraAprovador;
                }

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //========= Valida se Todos os Coordenadores Decidiram =============//
            //=========== Pega os Aprovadores do Pedido de Compra ==============//
            //==================================================================//

            let pedidoDeCompraAprovadores = await ERP.getManyById(Schema.PEDIDO_DE_COMPRA_APROVADORES, pedidoDeCompra.data.aprovadores);
            if(pedidoDeCompraAprovadores.status != 200){
                throw pedidoDeCompraAprovadores;
            }

            let pedidoDeCompraAprovadoresCoordenadores = pedidoDeCompraAprovadores.data.reduce((acc,pedidoDeCompraAprovador)=>{

                if(pedidoDeCompraAprovador.tipo == "Coordenador"){
                    acc.push(pedidoDeCompraAprovador)
                }

                return acc;

            },[]);

            let todosOsCoordenadoresDecidiram = pedidoDeCompraAprovadoresCoordenadores.every(({decisao})=> decisao != "A decidir");

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //============= Se Todos os Coordenadores Decidiram ================//
            //==================================================================//

            if(todosOsCoordenadoresDecidiram == true){

                //==================================================================//
                //============= Se Todos os Coordenadores Decidiram ================//
                //=============== Pegue o Tipo do Pedido de Compra =================//
                //==================================================================//

                let pedidoDeCompraTipo = pedidoDeCompra.data.codigo.includes("REV") ? "Revisão" : "Original";

                //==================================================================//
                //============= Se Todos os Coordenadores Decidiram ================//
                //================= Encontre a Decisão Geral =======================//
                //==================================================================//

                let pedidoDeCompraAprovado = pedidoDeCompraAprovadoresCoordenadores.every(({decisao})=> decisao == "Aprovou");
                let pedidoDeCompraDecisaoGeral = pedidoDeCompraAprovado ? "Aprovado" : "Reprovado";

                //==================================================================//
                //============= Se Todos os Coordenadores Decidiram ================//
                //============= Se o Pedido de Compra foi Aprovado ================//
                //==================================================================//

                if(pedidoDeCompraDecisaoGeral == "Aprovado"){

                    let pedidoDeCompraStatus = "Em Aprovação de Diretor";
                    let ordemDeServicoItensStatus = "AD";

                    //==================================================================//
                    //============= Se o Pedido de Compra foi Aprovado =================//
                    //====== Envie as Ordens de Serviço Iten de AA para AD =============//
                    //==================================================================//

                    let ordemDeServicoItensAprovarValores = ordemDeServicoItens.data.reduce((acc,ordemDeServicoItem)=>{
                    
                        if(ordemDeServicoItem.status == "AA"){

                            acc.push({
                                id: ordemDeServicoItem.id,
                                status: ordemDeServicoItensStatus,
                            });

                        }

                        return acc;
    
                    },[]);
    
                    let ordemDeServicoItensAprovar = await OrdemDeServicoItemService.alterarItens(ordemDeServicoItensAprovarValores);
                    if(ordemDeServicoItensAprovar.status != 200){
                        throw ordemDeServicoItensAprovar;
                    }

                    //==================================================================//
                    //============= Se o Pedido de Compra foi Aprovado =================//
                    //===== Envie o Pedido de Compra para Aprovação de Diretor =========//
                    //==================================================================//

                    let pedidoDeCompraAprovadoValores = {
                        id: pedidoDeCompra.data.id,
                        status: pedidoDeCompraStatus
                    }
        
                    let pedidoDeCompraAprovador = await PedidoDeCompraService.alterarPedido(pedidoDeCompraAprovadoValores);
                    if(pedidoDeCompraAprovador.status != 200){
                        throw pedidoDeCompraAprovador;
                    }

                    
                }

                //==================================================================//
                //============= Se Todos os Coordenadores Decidiram ================//
                //======== Retorne / Envie o Pedido de Compra para Alteração =======//
                //==================================================================//

                if(pedidoDeCompraTipo == "Original" && pedidoDeCompraDecisaoGeral == "Reprovado"){
                    
                    let pedidoDeCompraStatus = "Pedido em Alteração";
                    let ordemDeServicoItensStatus = "AL";

                    //==================================================================//
                    //========= Se o Pedido de Compra Original foi Reprovado ===========//
                    //====== Retorne as Ordens de Serviço Item de AA para RV ===========//
                    //==================================================================//

                    let ordemDeServicoItensRetornarValores = ordemDeServicoItens.data.reduce((acc,ordemDeServicoItem)=>{
                    
                        if(ordemDeServicoItem.status == "AA"){

                            acc.push({
                                id: ordemDeServicoItem.id,
                                status: ordemDeServicoItensStatus,
                            });

                        }

                        return acc;
    
                    },[]);
    
                    let ordemDeServicoItensRetornar = await OrdemDeServicoItemService.alterarItens(ordemDeServicoItensRetornarValores);
                    if(ordemDeServicoItensRetornar.status != 200){
                        throw ordemDeServicoItensRetornar;
                    }

                    //==================================================================//
                    //========= Se o Pedido de Compra Original foi Reprovado ===========//
                    //======== Retorne / Envie o Pedido de Compra para Alteração =======//
                    //==================================================================//

                    let pedidoDeCompraRetornarValores = {
                        id: pedidoDeCompra.data.id,
                        status: pedidoDeCompraStatus
                    }
        
                    let pedidoDeCompraRetornar = await PedidoDeCompraService.alterarPedido(pedidoDeCompraRetornarValores);
                    if(pedidoDeCompraRetornar.status != 200){
                        throw pedidoDeCompraRetornar;
                    }

                }
                
                //==================================================================//
                //============= Se Todos os Coordenadores Decidiram ================//
                //============= Pedido de Compra volta para Revisão ================//
                //==================================================================//

                if(pedidoDeCompraTipo == "Revisão" && pedidoDeCompraDecisaoGeral == "Reprovado"){

                    let pedidoDeCompraStatus = "Pedido em Revisão";
                    let ordemDeServicoItensStatus = "RV";

                    //==================================================================//
                    //======== Se a Revisão do Pedido de Compra foi Reprovado ==========//
                    //====== Retorne as Ordens de Serviço Item de AA para RV ===========//
                    //==================================================================//

                    let ordemDeServicoItensRetornarValores = ordemDeServicoItens.data.reduce((acc,ordemDeServicoItem)=>{
                    
                        if(ordemDeServicoItem.status == "AA"){

                            acc.push({
                                id: ordemDeServicoItem.id,
                                status: ordemDeServicoItensStatus,
                            });

                        }

                        return acc;
    
                    },[]);
    
                    let ordemDeServicoItensRetornar = await OrdemDeServicoItemService.alterarItens(ordemDeServicoItensRetornarValores);
                    if(ordemDeServicoItensRetornar.status != 200){
                        throw ordemDeServicoItensRetornar;
                    }

                    //==================================================================//
                    //======== Se a Revisão do Pedido de Compra foi Reprovado ==========//
                    //============ Retorne o Pedido de Compra para Revisão =============//
                    //==================================================================//

                    let pedidoDeCompraRetornarValores = {
                        id: pedidoDeCompra.data.id,
                        status: pedidoDeCompraStatus
                    }
        
                    let pedidoDeCompraRetornar = await PedidoDeCompraService.alterarPedido(pedidoDeCompraRetornarValores);
                    if(pedidoDeCompraRetornar.status != 200){
                        throw pedidoDeCompraRetornar;
                    }

                }

            }


        }catch(e){

            console.log(e);
            return pedidoDeCompra;

        }

        return pedidoDeCompra;

    },

    async decisaoDoDiretor(pedidoDeCompraID, decisaoValores={}){

        let pedidoDeCompra;

        try{

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //====================== Usuário Decisor ===========================//
            //==================================================================//

            let usuarioDecisor = decisaoValores.grupo == "Administradores" ? "Administrador" : "Diretor";

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //=================== Pega o Pedido de Compra ======================//
            //==================================================================//

            pedidoDeCompra = await ERP.getOneById(Schema.PEDIDO_DE_COMPRA, pedidoDeCompraID);
            if(pedidoDeCompra.status != 200){
                throw pedidoDeCompra;
            }

            //==================================================================//
            //=============== Pega o Pedido de Compra Itens ====================//
            //==================================================================//

            let pedidoDeCompraItens = await ERP.getManyById(Schema.PEDIDO_DE_COMPRA_ITENS, pedidoDeCompra.data.itens);
            if(pedidoDeCompraItens.status != 200){
                throw pedidoDeCompraItens;
            }

            //==================================================================//
            //==== Pega Ordens de Serviço Item dos Itens do Pedido de Compra ===//
            //==================================================================//

            let ordemDeServicoItensIDs = pedidoDeCompraItens?.data?.map(({ordemDeServicoItem})=>ordemDeServicoItem);

            let ordemDeServicoItens = await ERP.getManyById(Schema.ORDEM_DE_SERVICO_ITENS, ordemDeServicoItensIDs);
            if(ordemDeServicoItens.status != 200){
                throw ordemDeServicoItens;
            }

            //==================================================================//
            //=============== Pega o Pedido de Compra Parcelas =================//
            //==================================================================//

            let pedidoDeCompraParcelas = await ERP.getManyById(Schema.PEDIDO_DE_COMPRA_PARCELAS, pedidoDeCompra.data.parcelas);
            if(pedidoDeCompraParcelas.status != 200){
                throw pedidoDeCompraParcelas;
            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //========== Executa a Decisão como um Administrador ===============//
            //==================================================================//

            if(usuarioDecisor == "Administrador"){

                //==================================================================//
                //========== Executa a Decisão como um Administrador ===============//
                //=========== Pega os Aprovadores do Pedido de Compra ==============//
                //==================================================================//

                let pedidoDeCompraAprovadores = await ERP.getManyById(Schema.PEDIDO_DE_COMPRA_APROVADORES, pedidoDeCompra.data.aprovadores);
                if(pedidoDeCompraAprovadores.status != 200){
                    throw pedidoDeCompraAprovadores;
                }

                //==================================================================================//
                //================== Executa a Decisão como um Administrador =======================//
                //=========== Decide todas as Aprovações de Diretor do Pedido de Compra ============//
                //==================================================================================//

                let pedidoDeCompraAprovadoresValores = pedidoDeCompraAprovadores.data.reduce((acc,pedidoDeCompraAprovador)=>{

                    if(pedidoDeCompraAprovador.tipo == "Diretor"){

                        acc.push({
                            id: pedidoDeCompraAprovador.id,
                            decisao: decisaoValores.decisao,
                            justificativa: decisaoValores.justificativa,
                            dataDecisao: UtilDateTime.toFormatUTC({dateTime:decisaoValores.dataDecisao}),
                        });

                    }

                    return acc;

                },[]);

                pedidoDeCompraAprovadores = await this.alteraAprovadores(pedidoDeCompraAprovadoresValores);
                if(pedidoDeCompraAprovadores.status != 200){
                    throw pedidoDeCompraAprovadores;
                }

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //============= Executa a Decisão como um Diretor ==================//
            //==================================================================//

            if(usuarioDecisor == "Diretor"){

                //=========================================================================//
                //================= Executa a Decisão como um Diretor =====================//
                //========== Aplica a Decisão do Diretor do Pedido de Compra ==============//
                //=========================================================================//

                let pedidoDeCompraAprovadorValores = {
                    id: decisaoValores.aprovador,
                    decisao: decisaoValores.decisao,
                    justificativa: decisaoValores.justificativa,
                    dataDecisao: UtilDateTime.toFormatUTC({dateTime:decisaoValores.dataDecisao}),
                }

                let pedidoDeCompraAprovador = await this.alteraAprovador(pedidoDeCompraAprovadorValores);
                if(pedidoDeCompraAprovador.status != 200){
                    throw pedidoDeCompraAprovador;
                }

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //=========== Valida se Todos os Diretores Decidiram ===============//
            //=========== Pega os Aprovadores do Pedido de Compra ==============//
            //==================================================================//

            let pedidoDeCompraAprovadores = await ERP.getManyById(Schema.PEDIDO_DE_COMPRA_APROVADORES, pedidoDeCompra.data.aprovadores);
            if(pedidoDeCompraAprovadores.status != 200){
                throw pedidoDeCompraAprovadores;
            }

            let pedidoDeCompraAprovadoresDiretores = pedidoDeCompraAprovadores.data.reduce((acc,pedidoDeCompraAprovador)=>{

                if(pedidoDeCompraAprovador.tipo == "Diretor"){
                    acc.push(pedidoDeCompraAprovador)
                }

                return acc;

            },[]);

            let todosOsDiretoresDecidiram = pedidoDeCompraAprovadoresDiretores.every(({decisao})=> decisao != "A decidir");

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //=============== Se Todos os Diretores Decidiram ==================//
            //==================================================================//

            if(todosOsDiretoresDecidiram == true){

                //==================================================================//
                //=============== Se Todos os Diretores Decidiram ==================//
                //=============== Pegue o Tipo do Pedido de Compra =================//
                //==================================================================//

                let pedidoDeCompraTipo = pedidoDeCompra.data.codigo.includes("REV") ? "Revisão" : "Original";

                //==================================================================//
                //=============== Se Todos os Diretores Decidiram ==================//
                //================= Encontre a Decisão Geral =======================//
                //==================================================================//

                let pedidoDeCompraAprovado = pedidoDeCompraAprovadoresDiretores.every(({decisao})=> decisao == "Aprovou");
                let pedidoDeCompraDecisaoGeral = pedidoDeCompraAprovado ? "Aprovado" : "Reprovado";

                //==================================================================//
                //=============== Se Todos os Diretores Decidiram ==================//
                //============= Se o Pedido de Compra foi Aprovado ================//
                //==================================================================//

                if(pedidoDeCompraDecisaoGeral == "Aprovado"){

                    let pedidoDeCompraStatus = "Aguardando Envio ao Fornecedor";
                    let ordemDeServicoItensStatus = "AE";

                    //==================================================================//
                    //============= Se o Pedido de Compra foi Aprovado =================//
                    //====== Envie as Ordens de Serviço Iten de AD para AE =============//
                    //==================================================================//

                    let ordemDeServicoItensAprovarValores = ordemDeServicoItens.data.reduce((acc,ordemDeServicoItem)=>{
                    
                        if(ordemDeServicoItem.status == "AD"){

                            acc.push({
                                id: ordemDeServicoItem.id,
                                status: ordemDeServicoItensStatus,
                            });

                        }

                        return acc;
    
                    },[]);
    
                    let ordemDeServicoItensAprovar = await OrdemDeServicoItemService.alterarItens(ordemDeServicoItensAprovarValores);
                    if(ordemDeServicoItensAprovar.status != 200){
                        throw ordemDeServicoItensAprovar;
                    }

                    //====================================================================//
                    //=============== Se o Pedido de Compra foi Aprovado =================//
                    //=== Envie o Pedido de Compra para Aguardando Envio ao Fornecedor ===//
                    //====================================================================//

                    let pedidoDeCompraAprovadoValores = {
                        id: pedidoDeCompra.data.id,
                        status: pedidoDeCompraStatus,
                        dataCriacao: UtilDateTime.todayUTC(),
                    }
        
                    let pedidoDeCompraAprovador = await PedidoDeCompraService.alterarPedido(pedidoDeCompraAprovadoValores);
                    if(pedidoDeCompraAprovador.status != 200){
                        throw pedidoDeCompraAprovador;
                    }

                    
                }

                //==================================================================//
                //=============== Se Todos os Diretores Decidiram ==================//
                //======== Retorne / Envie o Pedido de Compra para Alteração =======//
                //==================================================================//

                if(pedidoDeCompraTipo == "Original" && pedidoDeCompraDecisaoGeral == "Reprovado"){
                    
                    let pedidoDeCompraStatus = "Pedido em Alteração";
                    let ordemDeServicoItensStatus = "AL";

                    //==================================================================//
                    //========= Se o Pedido de Compra Original foi Reprovado ===========//
                    //====== Retorne as Ordens de Serviço Item de AA para RV ===========//
                    //==================================================================//

                    let ordemDeServicoItensRetornarValores = ordemDeServicoItens.data.reduce((acc,ordemDeServicoItem)=>{
                    
                        if(ordemDeServicoItem.status == "AD"){

                            acc.push({
                                id: ordemDeServicoItem.id,
                                status: ordemDeServicoItensStatus,
                            });

                        }

                        return acc;
    
                    },[]);
    
                    let ordemDeServicoItensRetornar = await OrdemDeServicoItemService.alterarItens(ordemDeServicoItensRetornarValores);
                    if(ordemDeServicoItensRetornar.status != 200){
                        throw ordemDeServicoItensRetornar;
                    }

                    //==================================================================//
                    //========= Se o Pedido de Compra Original foi Reprovado ===========//
                    //======== Retorne / Envie o Pedido de Compra para Alteração =======//
                    //==================================================================//

                    let pedidoDeCompraRetornarValores = {
                        id: pedidoDeCompra.data.id,
                        status: pedidoDeCompraStatus
                    }
        
                    let pedidoDeCompraRetornar = await PedidoDeCompraService.alterarPedido(pedidoDeCompraRetornarValores);
                    if(pedidoDeCompraRetornar.status != 200){
                        throw pedidoDeCompraRetornar;
                    }

                }
                
                //==================================================================//
                //=============== Se Todos os Diretores Decidiram ==================//
                //============= Pedido de Compra volta para Revisão ================//
                //==================================================================//

                if(pedidoDeCompraTipo == "Revisão" && pedidoDeCompraDecisaoGeral == "Reprovado"){

                    let pedidoDeCompraStatus = "Pedido em Revisão";
                    let ordemDeServicoItensStatus = "RV";

                    //==================================================================//
                    //======== Se a Revisão do Pedido de Compra foi Reprovado ==========//
                    //====== Retorne as Ordens de Serviço Item de AD para RV ===========//
                    //==================================================================//

                    let ordemDeServicoItensRetornarValores = ordemDeServicoItens.data.reduce((acc,ordemDeServicoItem)=>{
                    
                        if(ordemDeServicoItem.status == "AD"){

                            acc.push({
                                id: ordemDeServicoItem.id,
                                status: ordemDeServicoItensStatus,
                            });

                        }

                        return acc;
    
                    },[]);
    
                    let ordemDeServicoItensRetornar = await OrdemDeServicoItemService.alterarItens(ordemDeServicoItensRetornarValores);
                    if(ordemDeServicoItensRetornar.status != 200){
                        throw ordemDeServicoItensRetornar;
                    }

                    //==================================================================//
                    //======== Se a Revisão do Pedido de Compra foi Reprovado ==========//
                    //============ Retorne o Pedido de Compra para Revisão =============//
                    //==================================================================//

                    let pedidoDeCompraRetornarValores = {
                        id: pedidoDeCompra.data.id,
                        status: pedidoDeCompraStatus
                    }
        
                    let pedidoDeCompraRetornar = await PedidoDeCompraService.alterarPedido(pedidoDeCompraRetornarValores);
                    if(pedidoDeCompraRetornar.status != 200){
                        throw pedidoDeCompraRetornar;
                    }

                }

            }


        }catch(e){

            console.log(e);
            return pedidoDeCompra;

        }

        return pedidoDeCompra;

    },

}